// extracted by mini-css-extract-plugin
export default {"wrapper":"Search_wrapper__VO39K","products":"Search_products__HJ0-J","header":"Search_header__8Ms-o","goBack":"Search_goBack__6zrqb","title":"Search_title__JDHYi"};